import { 
    IonCard,
    IonChip
} from "@ionic/react";
import React from "react";
import { Barn } from "../../models";

interface _Props {
    barn: Barn
    memberType?: ("admin" | "member")
}

const BasicBarnInfo: React.FC<_Props> = ({barn, memberType}) => {

    return (
        <IonCard className="bg-white ion-padding">
            <h3>{barn.name}</h3>
            {memberType &&
                <>
                    {memberType === "admin" ?
                        <IonChip className="rounded-2 font-weight-bold bg-dark text-white mx-0">Admin</IonChip>
                        :
                        <IonChip className="rounded-2 font-weight-bold bg-info text-white mx-0">Member</IonChip>
                    }
                </>
            }
            <p className="description">Barn id: {barn.id}</p>
        </IonCard>
    );
};

export default BasicBarnInfo;